import { Component, OnInit, ViewChild } from '@angular/core';
import { Config } from 'src/app/shared/config';
import { ClassificationService } from 'src/app/shared/services/classification.service';
import { IGroupClassification, IClassification, ICOAClassification } from 'src/app/shared/models/classification';
import { FrameworkService } from 'gadoe-framework';
import { IApplicationRoles, IGridPagination } from 'src/app/shared/models/common';
import { GridComponent, GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { State, process } from '@progress/kendo-data-query';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-codesearch',
  templateUrl: './codesearch.component.html',
  styleUrls: ['./codesearch.component.css']
})
export class CodesearchComponent implements OnInit {
  groups: IGroupClassification[] = [];
  tgroups: IGroupClassification[] = [];
  searchdetails: ICOAClassification[] = [];
  searchgridData: ICOAClassification[] = [];
  defaultCodeSearchGroup: IGroupClassification = { groupHeaderID: -1, name: 'ALL' };
  model: IClassification; loading: boolean;
  code: string;
  name: string;
  roleID: number;
  itroleID: number;
  show: boolean;
  constructor(private dataService: ClassificationService, private frameworkService: FrameworkService) { }
  state: State = {
    skip: 0,
    take: Config.gridPagination.gridPageSize,
    filter: null
  };
  fullstate: State = {
    skip: 0,
    take: 0,
    filter: null
  };

  gridPagination: IGridPagination = {
    buttonCount: Config.gridPagination.buttonCount,
    info: Config.gridPagination.info,
    type: Config.gridPagination.type,
    pageSizes: Config.gridPagination.pageSizes,
    previousNext: Config.gridPagination.previousNext,
    gridPageSize: Config.gridPagination.gridPageSize
  };

  gridData: GridDataResult;
  searchAllData: GridDataResult;
  @ViewChild('codesearchgrid') SearchGrid: GridComponent;
  ngOnInit() {
    Config.selectedTab = 8;
    this.modelInit();
    this.getGroupClassification();
  }
  modelInit() {
    this.model = {
      fiscalYearConfigID: -1,
      columnHeaderID: -1,
      groupclassificationID: -1,
      fiscalYear: -1,
      groupclassificationName: ''
    };
    this.code = '';
    this.name = '';
    this.loading = false;
    this.itroleID = IApplicationRoles.Administrator;
    this.roleID = Config.userProfile.itApplicationRoleID;
    this.show = true;
    this.reset();
    }
  getGroupClassification() {
    this.dataService.getGroupClassifications()
      .subscribe((response: IGroupClassification[]) => {
        this.groups = response;
        if (this.groups != null && this.groups.length > 0) {
          this.groups.unshift(this.defaultCodeSearchGroup);
          this.model.groupclassificationID = -1;
          this.tgroups = this.groups;
        }
      },
        (err: any) => this.frameworkService.logError(err),
        () => this.frameworkService.logInfo('getGroupClassification() retrieved groups'));
  }
  handleGroupHeaderFilter(value) {
    this.tgroups = this.groups.filter((s) => s.name.toLowerCase().indexOf(value.toLowerCase()) !== -1);
  }
  reset () {
    this.gridPagination = {
      buttonCount: 0,
      info: null,
      type: null,
      pageSizes: null,
      previousNext: null,
      gridPageSize: null
    };
  }
  varInit() {
    if (this.code === '') {
      this.code = null;
    }
    if (this.name === '') {
      this.name = null;
    }
    this.reset();
    this.state = {
      skip: 0,
      take: Config.gridPagination.gridPageSize,
      filter: null
    };
    this.gridPagination = {
      buttonCount: Config.gridPagination.buttonCount,
      info: Config.gridPagination.info,
      type: Config.gridPagination.type,
      pageSizes: Config.gridPagination.pageSizes,
      previousNext: Config.gridPagination.previousNext,
      gridPageSize: Config.gridPagination.gridPageSize
    };
    this.loading = true;
  }
  onClickSearch(event) {
    this.varInit();
    this.dataService.getCodeSearchDetails(this.code, this.name, this.model.groupclassificationID, Config.checkPublish).subscribe(
      (response: ICOAClassification[]) => {
        if (response.length !== null) {
          this.show = false;
          this.searchgridData = response;
          this.searchdetails = response.map(o => {
            return {
              sectionLineItemColumnID: o.sectionLineItemColumnID,
              groupHeaderID: o.groupHeaderID,
              groupHeaderName: o.groupHeaderName,
              sectionHeaderID: o.sectionHeaderID,
              lineItemID: o.lineItemID,
              createdBy: o.createdBy,
              name: o.name,
              code: o.code,
              description: o.description,
              isActive: o.isActive,
              sectionHeaderName: (o.sectionHeaderName === undefined || o.sectionHeaderName === null) ? 'tttt' : o.sectionHeaderName,
              sName: o.sName,
              isPublished: o.isPublished,
              isPublishedStatus: o.isPublishedStatus,
              groupHeaderIntroduction: o.groupHeaderIntroduction,
              startYear: o.startYear,
              activeStatus: o.activeStatus
            };
          });
          this.gridData = process(this.searchdetails, this.state);
        } else {
          this.show = true;
        }

        if (this.searchdetails.length <= Config.gridPagination.gridPageSize) {
          this.SearchGrid.pageable = false;
        }
        this.loading = false;
      },
      (err: any) => {
        this.frameworkService.logError(err),
          this.loading = false;
      },
      () => this.frameworkService.logInfo('getCodeSearchDetails() retrieved groups'));
  }
  groupclassificationOnChange() {
    this.searchdetails = null;
  }

  dataStateChange(state: DataStateChangeEvent): void {
    this.state = state;
    this.gridData = process(this.searchdetails, this.state);
  }
  public allData = (): GridDataResult => {
    this.searchAllData = process(this.searchgridData, this.fullstate);
    return this.searchAllData;
  }
}
